module.exports = __webpack_public_path__ + "static/media/18.c7aa89c2.JPG";